// extracted by mini-css-extract-plugin
export default {"table":"FeedbackTable_table__xJNYY","tablehead":"FeedbackTable_tablehead__tkASu","tablebody":"FeedbackTable_tablebody__2ZXZV","icons":"FeedbackTable_icons__fnDPd"};